import * as Yup from "yup";
import { passwordValidation } from "../../../accounts/components/signup/helpers";

export const emailFieldValidation = {
  email: Yup.string()
    .email("Please add valid email address")
    .required("Email is required")
    .typeError("Please add valid email address"),
};

export const signUpFormValidations = {
  ...emailFieldValidation,
  username: Yup.string()
    .required("User name is required")
    .typeError("Text type is required"),
  password: passwordValidation(),
};

export const signFormValidationSchema = Yup.object(signUpFormValidations);
